import { mapEnumApiResponse } from '../../core';
import { ApiRelatedPartyTypeEnum, RelatedPartyTypeEnum } from '../enums';

export function mapRelatedPartyTypeResponse(response: ApiRelatedPartyTypeEnum): RelatedPartyTypeEnum {
    return mapEnumApiResponse<RelatedPartyTypeEnum>(response, ApiRelatedPartyTypeEnum, RelatedPartyTypeEnum);
}
